<div *ngIf="activeProject?.id && !isLoading"
     class="content-container">
  <ng-container *ngTemplateOutlet="bluePrintManager"></ng-container>
</div>
<div *ngIf="!(activeProject?.id && !isLoading)"
     class="content-container">
  <nz-skeleton [nzActive]="true"></nz-skeleton>
</div>

<!-- BLUEPRINT CONTAINER -->
<ng-template #bluePrintManager>

  <!-- Project NAVBAR -->
  <nz-card class="project-details-card"
           [id]="CollapsePanels.ProjectTitle">
    <div class="project-header">
      <div class="title-bar">
        <h1 class="title">{{ activeProject?.name }} <span class="header-edit-project"><i class="fa-regular fa-pencil"
               (click)="navigateEditProject()"></i></span></h1>
        <!-- Collapse BluePrint Panel Button -->
        <!--
        <div class="title-bar-action-buttons">
          <div joyrideStep="completeWizardFirstStep"
               title="Collapse BluePrint Panel"
               text="Hide the design side menu to expand the content area and get a larger workspace.">
            <button nz-button
                    nz-tooltip
                    [nzTooltipTitle]="'Collapse BluePrint Panel'"
                    nzTooltipPlacement="left"
                    nzSize="small"
                    (click)="collapseBluePrintManager()">
              <i class="fa-regular fa-angle-left"></i>
            </button>
          </div>
        </div>
        -->
        <div class="toolbar-right">
          <!-- Sync project data -->
          <button nz-button
                  nz-tooltip="Sync Project Data"
                  nzSize="small"
                  (click)="syncProjectData()">
            <i class="fa-regular fa-arrows-rotate"></i></button>
          <button nz-button
                  nz-tooltip="Collapse All"
                  nzSize="small"
                  (click)="updateCollapsePanelVisibilities('collapse-all')">
            <i class="fa-light fa-arrow-up-from-line"></i></button>
        </div>
      </div>
      <div class="toolbar">
        <div class="toolbar-left">
          <!-- Dashboard Menu Button -->
          <!--
          <div joyrideStep="completeWizardThirdStep"
               title="Dashboard Menu"
               text="Use this menu to navigate to low-code customization features and tailor your project to your needs."
               (next)="collapseBluePrintManager()">
            <button nz-button
                    nz-tooltip
                    [nzTooltipTitle]="megaMenuTemplate"
                    [(nzTooltipVisible)]="megaMenuVisible"
                    nzTooltipOverlayClassName="mega-menu-overlay"
                    nzTooltipPlacement="bottomLeft"
                    nzSize="small"
                    nzTooltipTrigger="click">
              <rappider-icon [name]="'fas fa-ellipsis-h'"></rappider-icon>
            </button>
          </div>
          -->
        </div>

        <!-- <div class="toolbar-right">
          <i class="fa fa-info-circle"
             nz-tooltip
             [nzTooltipTitle]="projectInfoTooltip"
             nzTooltipPlacement="bottom"></i>
        </div> -->

      </div>
    </div>
  </nz-card>

  <!-- BLUEPRINT FEATURES -->
  <div class="content-scroll-area">

    <!-- PROJECT DESCRIPTION -->
    <div [class]="isStepVisitedForTheFirstTime(WizardSteps.ProjectDescription) ? 'project-design-container slide-in-bounce' : 'project-design-container'"
         [ngClass]="{ 'apply-blur': activeWizardStep === 0  }"
         [id]="CollapsePanels.ProjectDescription">
      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="Project Description"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.ProjectDescription)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.ProjectDescription, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.ProjectDescription)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.ProjectDescription)">
              <div *ngIf="aiStatusProjectDescriptionImproved === AIProgressStatus.InProgress"
                   class="ai-in-progress">
                <nz-skeleton [nzActive]="true"
                             [nzParagraph]="true"
                             [nzAvatar]="false"></nz-skeleton>
              </div>
              <ng-container *ngIf="aiStatusProjectDescriptionImproved !== AIProgressStatus.InProgress">
                <div class="project-description-editor-container">
                  <rappider-crud-fields-display [data]="activeProject"
                                                [editMode]="projectDescriptionEditMode"
                                                [config]="collapsePanelConfigs[CollapsePanels.ProjectDescription].crudForm"
                                                (formSubmit)="onProjectDescriptionSaved($event?.description)"
                                                (formCancel)="onProjectDescriptionEditCancelled()"></rappider-crud-fields-display>

                  <div *ngIf="!activeProject?.description">
                    <p>There is no description for this project. A description is important when Rapider AI attempts to
                      enhance your project using AI agents. However, if you prefer to build your app manually, you may
                      choose not to add a description.</p>
                  </div>
                </div>
              </ng-container>
            </ng-container>

          </nz-collapse-panel>
        </nz-collapse>

      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="visiblePanelKeys?.includes(CollapsePanels.ProjectDescription) ? collapsePanelConfigs[CollapsePanels.ProjectDescription]!.actionButtons : collapsePanelConfigs[CollapsePanels.ProjectDescription]!.actionButtons.slice(0,2)"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>

        <ng-container
                      *ngIf="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.ProjectDescription)">
          <ng-container *ngFor="let potItNote of getPostItNotes(CollapsePanels.ProjectDescription)">
            <rappider-post-it [title]="potItNote.title"
                              [noteText]="potItNote.content"
                              [isEditable]="false"
                              [color]="potItNote.color || PostItColor.Yellow"
                              [size]="potItNote.size || PostItSize.Small"
                              (noteUpdated)="onPostItNoteUpdated($event)"></rappider-post-it>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- PROJECT INFO -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 2"
         class="project-design-container"
         [id]="CollapsePanels.ProjectInformation">
      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="Project Information"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.ProjectInformation)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.ProjectInformation, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.ProjectInformation)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.ProjectInformation)">
              <p>
                Comprehensive information on the project's key attributes, including its unique identifier, creation
                metadata, and a
                breakdown of its core technological components.
              </p>

            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="visiblePanelKeys?.includes(CollapsePanels.ProjectInformation) ? collapsePanelConfigs[CollapsePanels.ProjectInformation]!.actionButtons : collapsePanelConfigs[CollapsePanels.ProjectInformation]!.actionButtons.slice(0,2)"
                                        [isExpanded]="projectInformationCollapseActive"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>
      </div>
    </div>

    <!-- SCOPE OF WORK -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 3"
         class="project-design-container"
         [id]="CollapsePanels.ScopeOfWork">
      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="Scope of Work"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.ScopeOfWork)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.ScopeOfWork, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.ScopeOfWork)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.ScopeOfWork)">
              <p>
                Rapider AI generates a scope of work for your MVP (minimum viable product) web application that has CRUD
                (create, read, update, delete ) features.
                <br><br>
                You can edit the scope of work to help Rapider AI understand your requirements better, on paid plans.
                <br><br>
                Our product management team offers a wide range of services to help you build your scope of work on
                enterprise plans.
              </p>

            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="collapsePanelConfigs[CollapsePanels.ScopeOfWork]!.actionButtons"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>
      </div>

    </div>

    <!-- DATA MODELS -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 4"
         class="project-design-container"
         [id]="CollapsePanels.DataModelsAndDatabase">
      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="Data Models and Database"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.DataModelsAndDatabase)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.DataModelsAndDatabase, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.DataModelsAndDatabase)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.DataModelsAndDatabase)">
              <!-- Data model cards -->
              <div *ngIf="projectModels?.length">
                <div class="template-wrapper">
                  <div class="cards-with-preview">
                    <div class="cards-wrapper">
                      <rappider-cards [items]="dataModelCardsConfig.cardsConfig?.items || []"
                                      [itemCountPerRow]="dataModelCardsConfig.cardsConfig?.itemCountPerRow || ItemPerRow.Two"
                                      [showTitleOnImage]="dataModelCardsConfig.cardsConfig?.showTitleOnImage || false"
                                      [showDescriptionOnImage]="dataModelCardsConfig.cardsConfig?.showDescriptionOnImage || false"
                                      [selectConfig]="dataModelCardsConfig.cardsConfig?.selectConfig"
                                      [paginationConfig]="dataModelCardsConfig.cardsConfig?.paginationConfig || {}"
                                      [showCheckMarkOnCard]="dataModelCardsConfig.cardsConfig?.showCheckMarkOnCard || false"
                                      [inputGroupConfig]="dataModelCardsConfig.cardsConfig?.inputGroupConfig"
                                      [topCards]="dataModelCardsConfig.cardsConfig?.topCards || []"
                                      [topCardsItemCountPerRow]="ItemPerRow.Two"
                                      [showSearchFilterLabel]="false"
                                      [detailedSearchActive]="true"
                                      (cardDetail)="onCardDetail($event)"
                                      (imageButtonClick)="onCardsSelect($event)"
                                      (topCardClick)="onDataModeltopCardClick($event)"></rappider-cards>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Data model relations -->
              <div *ngIf="projectModelRelations?.length"
                   class="data-relationships-section">
                <rappider-heading content="Data Relationships"
                                  [type]="HeadingType.H4"
                                  [class]="'data-relationships-heading'"></rappider-heading>
                <div class="template-wrapper data-relationships-cards-wrapper">
                  <div class="cards-with-preview">
                    <div class="cards-wrapper">
                      <rappider-cards [items]="dataModelRelationsCardsConfig.cardsConfig?.items || []"
                                      [itemCountPerRow]="dataModelRelationsCardsConfig.cardsConfig?.itemCountPerRow || ItemPerRow.Two"
                                      [showTitleOnImage]="dataModelRelationsCardsConfig.cardsConfig?.showTitleOnImage || false"
                                      [showDescriptionOnImage]="dataModelRelationsCardsConfig.cardsConfig?.showDescriptionOnImage || false"
                                      [selectConfig]="dataModelRelationsCardsConfig.cardsConfig?.selectConfig"
                                      [paginationConfig]="dataModelRelationsCardsConfig.cardsConfig?.paginationConfig || {}"
                                      [showCheckMarkOnCard]="dataModelRelationsCardsConfig.cardsConfig?.showCheckMarkOnCard || false"
                                      [inputGroupConfig]="dataModelRelationsCardsConfig.cardsConfig?.inputGroupConfig"
                                      [showSearchFilterLabel]="false"
                                      [detailedSearchActive]="true"
                                      (cardDetail)="onDataModelRelationCardDetail($event)"></rappider-cards>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="visiblePanelKeys?.includes(CollapsePanels.DataModelsAndDatabase) ? collapsePanelConfigs[CollapsePanels.DataModelsAndDatabase]!.actionButtons : collapsePanelConfigs[CollapsePanels.DataModelsAndDatabase]!.actionButtons.slice(0,2)"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>
      </div>
    </div>

    <!-- API Endpoints -->
    <a [id]="CollapsePanels.APIEndpoints"></a>
    <div *ngIf="activeWizardStep && activeWizardStep >= 5"
         class="project-design-container">
      <!-- [id]="CollapsePanels.APIEndpoints" -->
      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="API Endpoints"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.APIEndpoints)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.APIEndpoints, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.APIEndpoints)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.APIEndpoints)">
              <div *ngIf="projectModels?.length">
                <div class="template-wrapper">
                  <div class="cards-with-preview">
                    <div class="cards-wrapper">
                      <rappider-cards [items]="endpointsCardsConfig.cardsConfig?.items || []"
                                      [itemCountPerRow]="endpointsCardsConfig.cardsConfig?.itemCountPerRow || ItemPerRow.Two"
                                      [showTitleOnImage]="endpointsCardsConfig.cardsConfig?.showTitleOnImage || false"
                                      [showDescriptionOnImage]="endpointsCardsConfig.cardsConfig?.showDescriptionOnImage || false"
                                      [selectConfig]="endpointsCardsConfig.cardsConfig?.selectConfig"
                                      [paginationConfig]="endpointsCardsConfig.cardsConfig?.paginationConfig || {}"
                                      [showCheckMarkOnCard]="endpointsCardsConfig.cardsConfig?.showCheckMarkOnCard || false"
                                      [inputGroupConfig]="endpointsCardsConfig.cardsConfig?.inputGroupConfig"
                                      [topCards]="endpointsCardsConfig.cardsConfig?.topCards || []"
                                      [topCardsItemCountPerRow]="ItemPerRow.Two"
                                      [showSearchFilterLabel]="false"
                                      [detailedSearchActive]="true"
                                      (cardDetail)="clickEndpointCard($event)"
                                      (imageButtonClick)="clickEndpointCard($event)"
                                      (topCardClick)="onEndpointtopCardClick($event)"></rappider-cards>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="collapsePanelConfigs[CollapsePanels.APIEndpoints]!.actionButtons"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>
      </div>
    </div>

    <!-- UI DESIGN SYSTEM -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 6"
         class="project-design-container"
         [id]="CollapsePanels.DesignSystem">
      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="Design System"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.DesignSystem)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.DesignSystem, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.DesignSystem)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.DesignSystem)">
              <!-- Content for the Design System Section -->
              <!-- <rappider-component-definitions-preview></rappider-component-definitions-preview> -->
              <rappider-element-menu [componentDefinitions]="componentDefinitions || []"
                                     [isComponentUsingInModal]="true"
                                     [addComponentToTheActiveContentEditorOnSelection]="false"
                                     (componentAdded)="onElementComponentSelected($event)"></rappider-element-menu>

            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>

      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="collapsePanelConfigs[CollapsePanels.DesignSystem]!.actionButtons"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>

        <ng-container
                      *ngIf="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.DesignSystem)">
          <ng-container *ngFor="let potItNote of getPostItNotes(CollapsePanels.DesignSystem)">
            <rappider-post-it [title]="potItNote.title"
                              [noteText]="potItNote.content"
                              [isEditable]="false"
                              [color]="potItNote.color || PostItColor.Yellow"
                              [size]="potItNote.size || PostItSize.Small"
                              (noteUpdated)="onPostItNoteUpdated($event)"></rappider-post-it>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- THEME -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 7"
         class="project-design-container"
         [id]="CollapsePanels.Theme">
      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="Theme"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.Theme)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.Theme, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.Theme)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.Theme)">
              <!-- Content for the Theme Section -->
              <div *ngIf="projectThemes?.length">
                <div class="template-wrapper">
                  <div class="cards-with-preview">
                    <div class="cards-wrapper">
                      <rappider-cards [items]="themeCardsConfig.cardsConfig?.items || []"
                                      [itemCountPerRow]="themeCardsConfig.cardsConfig?.itemCountPerRow || ItemPerRow.Two"
                                      [showTitleOnImage]="themeCardsConfig.cardsConfig?.showTitleOnImage || false"
                                      [showDescriptionOnImage]="themeCardsConfig.cardsConfig?.showDescriptionOnImage || false"
                                      [selectConfig]="themeCardsConfig.cardsConfig?.selectConfig"
                                      [paginationConfig]="themeCardsConfig.cardsConfig?.paginationConfig || {}"
                                      [showCheckMarkOnCard]="themeCardsConfig.cardsConfig?.showCheckMarkOnCard || false"
                                      [inputGroupConfig]="themeCardsConfig.cardsConfig?.inputGroupConfig"
                                      [topCards]="themeCardsConfig.cardsConfig?.topCards || []"
                                      [topCardsItemCountPerRow]="ItemPerRow.Two"
                                      [clickedCardId]="clickedThemeCardId || ''"
                                      [showSearchFilterLabel]="false"
                                      [detailedSearchActive]="true"
                                      (cardDetail)="onCardDetail($event)"
                                      (imageButtonClick)="onCardsSelect($event)"
                                      (topCardClick)="onThemetopCardClick($event)"></rappider-cards>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>

      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="visiblePanelKeys?.includes(CollapsePanels.Theme) ? collapsePanelConfigs[CollapsePanels.Theme]!.actionButtons : collapsePanelConfigs[CollapsePanels.Theme]!.actionButtons.slice(0,2)"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>

        <ng-container
                      *ngIf="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.Theme)">
          <ng-container *ngFor="let potItNote of getPostItNotes(CollapsePanels.Theme)">
            <rappider-post-it [title]="potItNote.title"
                              [noteText]="potItNote.content"
                              [isEditable]="false"
                              [color]="potItNote.color || PostItColor.Yellow"
                              [size]="potItNote.size || PostItSize.Small"
                              (noteUpdated)="onPostItNoteUpdated($event)"></rappider-post-it>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- UI PAGE LAYOUTS -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 8"
         class="project-design-container"
         [id]="CollapsePanels.UIPageLayouts">
      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="UI Page Layouts"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.UIPageLayouts)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.UIPageLayouts, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.UIPageLayouts)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.UIPageLayouts)">
              <!-- Content for the UI Page Layouts Section -->
              <div *ngIf="layouts?.length">
                <div class="template-wrapper">
                  <div class="cards-with-preview">
                    <div class="cards-wrapper">
                      <rappider-cards [items]="layoutCardsConfig.cardsConfig?.items || []"
                                      [itemCountPerRow]="layoutCardsConfig.cardsConfig?.itemCountPerRow || ItemPerRow.Two"
                                      [showTitleOnImage]="layoutCardsConfig.cardsConfig?.showTitleOnImage || false"
                                      [showDescriptionOnImage]="layoutCardsConfig.cardsConfig?.showDescriptionOnImage || false"
                                      [selectConfig]="layoutCardsConfig.cardsConfig?.selectConfig"
                                      [paginationConfig]="layoutCardsConfig.cardsConfig?.paginationConfig || {}"
                                      [showCheckMarkOnCard]="layoutCardsConfig.cardsConfig?.showCheckMarkOnCard || false"
                                      [inputGroupConfig]="layoutCardsConfig.cardsConfig?.inputGroupConfig"
                                      [topCards]="layoutCardsConfig.cardsConfig?.topCards || []"
                                      [topCardsItemCountPerRow]="ItemPerRow.Two"
                                      [clickedCardId]="clickedLayoutCardId || ''"
                                      [showSearchFilterLabel]="false"
                                      [detailedSearchActive]="true"
                                      (cardDetail)="onCardDetail($event)"
                                      (imageButtonClick)="onCardsSelect($event)"
                                      (topCardClick)="onLayouttopCardClick($event)"></rappider-cards>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

          </nz-collapse-panel>
        </nz-collapse>

      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="collapsePanelConfigs[CollapsePanels.UIPageLayouts]!.actionButtons"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>

        <ng-container
                      *ngIf="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.UIPageLayouts)">
          <ng-container *ngFor="let potItNote of getPostItNotes(CollapsePanels.UIPageLayouts)">
            <rappider-post-it [title]="potItNote.title"
                              [noteText]="potItNote.content"
                              [isEditable]="false"
                              [color]="potItNote.color || PostItColor.Yellow"
                              [size]="potItNote.size || PostItSize.Small"
                              (noteUpdated)="onPostItNoteUpdated($event)"></rappider-post-it>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- UI PAGES -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 9"
         class="project-design-container"
         [id]="CollapsePanels.UIPages">
      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="UI Pages"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.UIPages)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.UIPages, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.UIPages)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.UIPages)">
              <!-- Content for the UI Pages Section -->
              <div class="ui-pages-wrapper"
                   *ngIf="pages?.length">
                <div class="template-wrapper">
                  <div class="cards-with-preview">
                    <div class="cards-wrapper">
                      <rappider-cards [items]="pageCardsConfig.cardsConfig?.items || []"
                                      [itemCountPerRow]="pageCardsConfig.cardsConfig?.itemCountPerRow || ItemPerRow.Two"
                                      [showTitleOnImage]="pageCardsConfig.cardsConfig?.showTitleOnImage || false"
                                      [showDescriptionOnImage]="pageCardsConfig.cardsConfig?.showDescriptionOnImage || false"
                                      [selectConfig]="pageCardsConfig.cardsConfig?.selectConfig"
                                      [paginationConfig]="pageCardsConfig.cardsConfig?.paginationConfig || {}"
                                      [showCheckMarkOnCard]="pageCardsConfig.cardsConfig?.showCheckMarkOnCard || false"
                                      [inputGroupConfig]="pageCardsConfig.cardsConfig?.inputGroupConfig"
                                      [grouppedCards]="grouppedCards || []"
                                      [topCards]="pageCardsConfig.cardsConfig?.topCards || []"
                                      [topCardsItemCountPerRow]="ItemPerRow.Two"
                                      [showSearchFilterLabel]="false"
                                      [detailedSearchActive]="true"
                                      (cardDetail)="onCardDetail($event)"
                                      (topCardClick)="onPagetopCardClick($event)"
                                      (imageButtonClick)="onCardsSelect($event)"></rappider-cards>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="visiblePanelKeys?.includes(CollapsePanels.UIPages) ? collapsePanelConfigs[CollapsePanels.UIPages]!.actionButtons : collapsePanelConfigs[CollapsePanels.UIPages]!.actionButtons.slice(0,2)"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>

        <!-- <ng-container
            *ngIf="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.UIPages)">
<ng-container *ngFor="let potItNote of getPostItNotes(CollapsePanels.UIPages)">
  <rappider-post-it [title]="potItNote.title"
                    [noteText]="potItNote.content"
                    [isEditable]="false"
                    [color]="potItNote.color || PostItColor.Yellow"
                    [size]="potItNote.size || PostItSize.Small"
                    (noteUpdated)="onPostItNoteUpdated($event)"></rappider-post-it>
</ng-container>
</ng-container> -->
      </div>
    </div>

    <!-- UI BUSINESS PROCESSES -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 10"
         class="project-design-container"
         [id]="CollapsePanels.UIBusinessProcesses">
      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="UI Business Processes"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.UIBusinessProcesses)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.UIBusinessProcesses, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.UIBusinessProcesses)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.UIBusinessProcesses)">
              <!-- Content for the UI Business Processes Section -->
              <div *ngIf="uiDataStores?.length">
                <div class="template-wrapper">
                  <div class="cards-with-preview">
                    <div class="cards-wrapper">
                      <rappider-cards [items]="uiDataStoreCardsConfig.cardsConfig?.items || []"
                                      [itemCountPerRow]="uiDataStoreCardsConfig.cardsConfig?.itemCountPerRow || ItemPerRow.Two"
                                      [showTitleOnImage]="uiDataStoreCardsConfig.cardsConfig?.showTitleOnImage || false"
                                      [showDescriptionOnImage]="uiDataStoreCardsConfig.cardsConfig?.showDescriptionOnImage || false"
                                      [selectConfig]="uiDataStoreCardsConfig.cardsConfig?.selectConfig"
                                      [paginationConfig]="uiDataStoreCardsConfig.cardsConfig?.paginationConfig || {}"
                                      [showCheckMarkOnCard]="uiDataStoreCardsConfig.cardsConfig?.showCheckMarkOnCard || false"
                                      [inputGroupConfig]="uiDataStoreCardsConfig.cardsConfig?.inputGroupConfig"
                                      [topCards]="uiDataStoreCardsConfig.cardsConfig?.topCards || []"
                                      [topCardsItemCountPerRow]="ItemPerRow.Two"
                                      [showSearchFilterLabel]="false"
                                      [detailedSearchActive]="true"
                                      (cardDetail)="onCardDetail($event)"
                                      (imageButtonClick)="onCardsSelect($event)"
                                      (topCardClick)="onUIDataStoretopCardClick($event)"></rappider-cards>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>

      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="visiblePanelKeys?.includes(CollapsePanels.UIBusinessProcesses) ? collapsePanelConfigs[CollapsePanels.UIBusinessProcesses]!.actionButtons : collapsePanelConfigs[CollapsePanels.UIBusinessProcesses]!.actionButtons.slice(0,2)"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>

        <ng-container
                      *ngIf="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.UIBusinessProcesses)">
          <ng-container *ngFor="let potItNote of getPostItNotes(CollapsePanels.UIBusinessProcesses)">
            <rappider-post-it [title]="potItNote.title"
                              [noteText]="potItNote.content"
                              [isEditable]="false"
                              [color]="potItNote.color || PostItColor.Yellow"
                              [size]="potItNote.size || PostItSize.Small"
                              (noteUpdated)="onPostItNoteUpdated($event)"></rappider-post-it>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- MESSAGE TEMPLATES -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 11"
         class="project-design-container"
         [id]="CollapsePanels.MessageTemplates">
      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="Message Templates"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.MessageTemplates)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.MessageTemplates, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.MessageTemplates)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.MessageTemplates)">
              <!-- Content for the MessageTemplates Section -->

              <div *ngIf="messageTemplates?.length">
                <div class="template-wrapper">
                  <div class="cards-with-preview">
                    <div class="cards-wrapper">
                      <rappider-cards [items]="messageTemplatesCardsConfig.cardsConfig?.items || []"
                                      [itemCountPerRow]="messageTemplatesCardsConfig.cardsConfig?.itemCountPerRow || ItemPerRow.Two"
                                      [showTitleOnImage]="messageTemplatesCardsConfig.cardsConfig?.showTitleOnImage || false"
                                      [showDescriptionOnImage]="messageTemplatesCardsConfig.cardsConfig?.showDescriptionOnImage || false"
                                      [selectConfig]="messageTemplatesCardsConfig.cardsConfig?.selectConfig"
                                      [paginationConfig]="messageTemplatesCardsConfig.cardsConfig?.paginationConfig || {}"
                                      [showCheckMarkOnCard]="messageTemplatesCardsConfig.cardsConfig?.showCheckMarkOnCard || false"
                                      [inputGroupConfig]="messageTemplatesCardsConfig.cardsConfig?.inputGroupConfig"
                                      [topCards]="messageTemplatesCardsConfig.cardsConfig?.topCards || []"
                                      [topCardsItemCountPerRow]="ItemPerRow.Two"
                                      [showSearchFilterLabel]="false"
                                      [detailedSearchActive]="true"
                                      (cardDetail)="onCardDetail($event)"
                                      (topCardClick)="onTemplatetopCardClick($event)"></rappider-cards>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <rappider-markdown-viewer
                                                [markdownText]="MESSAGE_TEMPLATES_EXPLANATION"></rappider-markdown-viewer> -->
              <!-- <rappider-message-template-display
                                                       [messageTemplate]="messageTemplate"></rappider-message-template-display> -->
            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>

      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="visiblePanelKeys?.includes(CollapsePanels.MessageTemplates) ? collapsePanelConfigs[CollapsePanels.MessageTemplates]!.actionButtons : collapsePanelConfigs[CollapsePanels.MessageTemplates]!.actionButtons.slice(0,2)"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>

        <ng-container
                      *ngIf="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.ServerSideBusinessProcesses)">
          <ng-container *ngFor="let potItNote of getPostItNotes(CollapsePanels.ServerSideBusinessProcesses)">
            <rappider-post-it [title]="potItNote.title"
                              [noteText]="potItNote.content"
                              [isEditable]="false"
                              [color]="potItNote.color || PostItColor.Yellow"
                              [size]="potItNote.size || PostItSize.Small"
                              (noteUpdated)="onPostItNoteUpdated($event)"></rappider-post-it>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- SERVER SIDE BUSINESS PROCESSES -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 12"
         class="project-design-container"
         [id]="CollapsePanels.ServerSideBusinessProcesses">
      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="Server Side Business Processes"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.ServerSideBusinessProcesses)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.ServerSideBusinessProcesses, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.ServerSideBusinessProcesses)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.ServerSideBusinessProcesses)">
              <!-- Content for the Server Side Business Processes Section -->
              <section *ngIf="!starterNodes?.length">
                <rappider-heading content="There is no workflow for this project."
                                  type="h6"></rappider-heading>
              </section>
              <div *ngIf="starterNodes?.length">
                <div class="template-wrapper">
                  <div class="cards-with-preview">
                    <div class="cards-wrapper">
                      <rappider-cards [items]="serverSideBusinessProcessesCardsConfig.cardsConfig?.items || []"
                                      [itemCountPerRow]="serverSideBusinessProcessesCardsConfig.cardsConfig?.itemCountPerRow || ItemPerRow.Two"
                                      [showTitleOnImage]="serverSideBusinessProcessesCardsConfig.cardsConfig?.showTitleOnImage || false"
                                      [showDescriptionOnImage]="serverSideBusinessProcessesCardsConfig.cardsConfig?.showDescriptionOnImage || false"
                                      [selectConfig]="serverSideBusinessProcessesCardsConfig.cardsConfig?.selectConfig"
                                      [paginationConfig]="serverSideBusinessProcessesCardsConfig.cardsConfig?.paginationConfig || {}"
                                      [showCheckMarkOnCard]="serverSideBusinessProcessesCardsConfig.cardsConfig?.showCheckMarkOnCard || false"
                                      [inputGroupConfig]="serverSideBusinessProcessesCardsConfig.cardsConfig?.inputGroupConfig"
                                      [showSearchFilterLabel]="false"
                                      [detailedSearchActive]="true"
                                      (cardDetail)="onCardDetail($event)"
                                      (imageButtonClick)="onCardDetail($event)"></rappider-cards>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>

      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="visiblePanelKeys?.includes(CollapsePanels.ServerSideBusinessProcesses) ? collapsePanelConfigs[CollapsePanels.ServerSideBusinessProcesses]!.actionButtons : collapsePanelConfigs[CollapsePanels.ServerSideBusinessProcesses]!.actionButtons.slice(0,2)"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>

        <ng-container
                      *ngIf="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.ServerSideBusinessProcesses)">
          <ng-container *ngFor="let potItNote of getPostItNotes(CollapsePanels.ServerSideBusinessProcesses)">
            <rappider-post-it [title]="potItNote.title"
                              [noteText]="potItNote.content"
                              [isEditable]="false"
                              [color]="potItNote.color || PostItColor.Yellow"
                              [size]="potItNote.size || PostItSize.Small"
                              (noteUpdated)="onPostItNoteUpdated($event)"></rappider-post-it>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- ENVIRONMENT VARIABLES -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 13"
         class="project-design-container"
         [id]="CollapsePanels.SettingsVariablesAndEnvironments">
      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="Settings, Variables and Environments"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.SettingsVariablesAndEnvironments)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.SettingsVariablesAndEnvironments, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.SettingsVariablesAndEnvironments)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.SettingsVariablesAndEnvironments)">
              <!-- Content for the Project Settings Section -->
              <div class="ui-pages-wrapper"
                   *ngIf="projectSettingsCardsConfig.cardsConfig?.items?.length">
                <div class="template-wrapper">
                  <div class="cards-with-preview">
                    <div class="cards-wrapper">
                      <rappider-cards [items]="projectSettingsCardsConfig.cardsConfig?.items || []"
                                      [itemCountPerRow]="projectSettingsCardsConfig.cardsConfig?.itemCountPerRow || ItemPerRow.Two"
                                      [showTitleOnImage]="projectSettingsCardsConfig.cardsConfig?.showTitleOnImage || false"
                                      [showDescriptionOnImage]="projectSettingsCardsConfig.cardsConfig?.showDescriptionOnImage || false"
                                      [selectConfig]="projectSettingsCardsConfig.cardsConfig?.selectConfig"
                                      [showSearchSection]="projectSettingsCardsConfig.cardsConfig?.showSearchSection || false"
                                      [titleText]="projectSettingsCardsConfig.cardsConfig?.titleText || {}"
                                      [showCheckMarkOnCard]="projectSettingsCardsConfig.cardsConfig?.showCheckMarkOnCard || false"
                                      [paginationConfig]="projectSettingsCardsConfig.cardsConfig?.paginationConfig || {}"
                                      [showSearchFilterLabel]="false"
                                      [detailedSearchActive]="true"
                                      (cardDetail)="onProjectSettingsCardDetail($event)"
                                      (imageButtonClick)="onProjectSettingsCardAction($event)">
                      </rappider-cards>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ui-pages-wrapper"
                   *ngIf="projectEnvironmentCardsConfig.cardsConfig?.items?.length">
                <div class="template-wrapper">
                  <div class="cards-with-preview">
                    <div class="cards-wrapper">
                      <rappider-cards [items]="projectEnvironmentCardsConfig.cardsConfig?.items || []"
                                      [itemCountPerRow]="projectEnvironmentCardsConfig.cardsConfig?.itemCountPerRow"
                                      [showTitleOnImage]="projectEnvironmentCardsConfig.cardsConfig?.showTitleOnImage"
                                      [showDescriptionOnImage]="projectEnvironmentCardsConfig.cardsConfig?.showDescriptionOnImage"
                                      [selectConfig]="projectEnvironmentCardsConfig.cardsConfig?.selectConfig"
                                      [showSearchSection]="projectEnvironmentCardsConfig.cardsConfig?.showSearchSection"
                                      [titleText]="projectEnvironmentCardsConfig.cardsConfig?.titleText"
                                      [showCheckMarkOnCard]="projectEnvironmentCardsConfig.cardsConfig?.showCheckMarkOnCard"
                                      [paginationConfig]="projectEnvironmentCardsConfig.cardsConfig?.paginationConfig"
                                      [isDynamicPagination]="false"
                                      [showSearchFilterLabel]="false"
                                      [detailedSearchActive]="true"
                                      (cardDetail)="onProjectEnvironmentCardDetail($event)"
                                      (imageButtonClick)="onProjectEnvironmentCardAction($event)">
                      </rappider-cards>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>

      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="collapsePanelConfigs[CollapsePanels.SettingsVariablesAndEnvironments]!.actionButtons"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>

        <ng-container
                      *ngIf="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.SettingsVariablesAndEnvironments)">
          <ng-container *ngFor="let potItNote of getPostItNotes(CollapsePanels.SettingsVariablesAndEnvironments)">
            <rappider-post-it [title]="potItNote.title"
                              [noteText]="potItNote.content"
                              [isEditable]="false"
                              [color]="potItNote.color || PostItColor.Yellow"
                              [size]="potItNote.size || PostItSize.Small"
                              (noteUpdated)="onPostItNoteUpdated($event)"></rappider-post-it>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- YOUR APP IS READY -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 14"
         class="project-design-container"
         [id]="CollapsePanels.GenerateProjectCode">
      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="Generate Project Code"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.GenerateProjectCode)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.GenerateProjectCode, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.GenerateProjectCode)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.GenerateProjectCode)">
              <!-- Content for the Generate Project Code Section -->
              <div *ngIf="projectVersions?.length">
                <div class="template-wrapper">
                  <div class="cards-with-preview">
                    <div class="cards-wrapper">
                      <rappider-cards [items]="projectVersionCardsConfig.cardsConfig?.items || []"
                                      [itemCountPerRow]="projectVersionCardsConfig.cardsConfig?.itemCountPerRow || ItemPerRow.Two"
                                      [showTitleOnImage]="projectVersionCardsConfig.cardsConfig?.showTitleOnImage || false"
                                      [showDescriptionOnImage]="projectVersionCardsConfig.cardsConfig?.showDescriptionOnImage || false"
                                      [selectConfig]="projectVersionCardsConfig.cardsConfig?.selectConfig"
                                      [paginationConfig]="projectVersionCardsConfig.cardsConfig?.paginationConfig"
                                      [showCheckMarkOnCard]="projectVersionCardsConfig.cardsConfig?.showCheckMarkOnCard || false"
                                      [inputGroupConfig]="projectVersionCardsConfig.cardsConfig?.inputGroupConfig"
                                      [topCards]="projectVersionCardsConfig.cardsConfig?.topCards"
                                      [topCardsItemCountPerRow]="ItemPerRow.Two"
                                      [showSearchFilterLabel]="false"
                                      [detailedSearchActive]="true"
                                      (cardDetail)="onCardDetail($event)"
                                      (imageButtonClick)="onCardsSelect($event)"
                                      (topCardClick)="onVersiontopCardClick($event)"></rappider-cards>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>

      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="collapsePanelConfigs[CollapsePanels.GenerateProjectCode]!.actionButtons"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>

        <ng-container
                      *ngIf="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.GenerateProjectCode)">
          <ng-container *ngFor="let potItNote of getPostItNotes(CollapsePanels.GenerateProjectCode)">
            <rappider-post-it [title]="potItNote.title"
                              [noteText]="potItNote.content"
                              [isEditable]="false"
                              [color]="potItNote.color || PostItColor.Yellow"
                              [size]="potItNote.size || PostItSize.Small"
                              (noteUpdated)="onPostItNoteUpdated($event)"></rappider-post-it>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- PROJECT MEMBERS -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 15"
         class="project-design-container"
         [id]="CollapsePanels.ProjectMembers">

      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="Project Members"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.ProjectMembers)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.ProjectMembers, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.ProjectMembers)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.ProjectMembers)">
              <div class="template-wrapper">
                <div class="cards-with-preview">
                  <div class="cards-wrapper">
                    <rappider-cards [items]="projectMembersCardsConfig.cardsConfig?.items || []"
                                    [itemCountPerRow]="projectMembersCardsConfig.cardsConfig?.itemCountPerRow || ItemPerRow.Two"
                                    [showTitleOnImage]="projectMembersCardsConfig.cardsConfig?.showTitleOnImage || false"
                                    [showDescriptionOnImage]="projectMembersCardsConfig.cardsConfig?.showDescriptionOnImage || false"
                                    [selectConfig]="projectMembersCardsConfig.cardsConfig?.selectConfig"
                                    [paginationConfig]="projectMembersCardsConfig.cardsConfig?.paginationConfig || {}"
                                    [showCheckMarkOnCard]="projectMembersCardsConfig.cardsConfig?.showCheckMarkOnCard || false"
                                    [inputGroupConfig]="projectMembersCardsConfig.cardsConfig?.inputGroupConfig"
                                    [topCards]="projectMembersCardsConfig.cardsConfig?.topCards || []"
                                    [topCardsItemCountPerRow]="ItemPerRow.Two"
                                    [showSearchFilterLabel]="false"
                                    [detailedSearchActive]="false"
                                    [showSearchSection]="false"
                                    (cardDetail)="onCardDetail($event)"
                                    (topCardClick)="onProjectMemberstopCardClick($event)"></rappider-cards>
                  </div>
                </div>
              </div>
            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="collapsePanelConfigs[CollapsePanels.ProjectMembers]!.actionButtons"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>
      </div>
    </div>

    <!-- SHARE PROJECT -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 15"
         class="project-design-container"
         [id]="CollapsePanels.ShareApplication">

      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="Share Application"
                             [nzExtra]="getStepStatusTemplate(WizardSteps.ShareApplication)"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.ShareApplication, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.ShareApplication)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.ShareApplication)">
              <div class="template-wrapper">
                <div class="cards-with-preview">
                  <div class="cards-wrapper">
                    <rappider-cards [items]="shareApplicationCardsConfig.cardsConfig?.items || []"
                                    [itemCountPerRow]="shareApplicationCardsConfig.cardsConfig?.itemCountPerRow || ItemPerRow.Two"
                                    [showTitleOnImage]="shareApplicationCardsConfig.cardsConfig?.showTitleOnImage || false"
                                    [showDescriptionOnImage]="shareApplicationCardsConfig.cardsConfig?.showDescriptionOnImage || false"
                                    [selectConfig]="shareApplicationCardsConfig.cardsConfig?.selectConfig"
                                    [paginationConfig]="shareApplicationCardsConfig.cardsConfig?.paginationConfig || {}"
                                    [showCheckMarkOnCard]="shareApplicationCardsConfig.cardsConfig?.showCheckMarkOnCard || false"
                                    [inputGroupConfig]="shareApplicationCardsConfig.cardsConfig?.inputGroupConfig"
                                    [topCards]="shareApplicationCardsConfig.cardsConfig?.topCards || []"
                                    [topCardsItemCountPerRow]="ItemPerRow.Two"
                                    [showSearchFilterLabel]="false"
                                    [detailedSearchActive]="false"
                                    [showSearchSection]="false"
                                    (cardDetail)="onCardDetail($event)"
                                    (topCardClick)="onShareApplicationtopCardClick($event)"></rappider-cards>
                  </div>
                </div>
              </div>
            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="collapsePanelConfigs[CollapsePanels.ShareApplication]!.actionButtons"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>
      </div>
    </div>


    <!-- DEPLOY -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 15"
         class="project-design-container"
         [id]="CollapsePanels.Deploy">

      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="Deploy and Preview"
                             [nzExtra]="getStepStatusTemplateForDeployment()"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.Deploy, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.Deploy)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.Deploy)">
              <div class="template-wrapper">
                <div class="cards-with-preview">
                  <div class="cards-wrapper">
                    <rappider-cards [items]="deployCardsConfig.cardsConfig?.items || []"
                                    [itemCountPerRow]="deployCardsConfig.cardsConfig?.itemCountPerRow"
                                    [showTitleOnImage]="deployCardsConfig.cardsConfig?.showTitleOnImage"
                                    [showDescriptionOnImage]="deployCardsConfig.cardsConfig?.showDescriptionOnImage"
                                    [selectConfig]="deployCardsConfig.cardsConfig?.selectConfig"
                                    [showSearchSection]="deployCardsConfig.cardsConfig?.showSearchSection"
                                    [titleText]="deployCardsConfig.cardsConfig?.titleText"
                                    [showCheckMarkOnCard]="deployCardsConfig.cardsConfig?.showCheckMarkOnCard"
                                    [customIcon]="deployCardsConfig.cardsConfig?.customIcon"
                                    [paginationConfig]="deployCardsConfig.cardsConfig?.paginationConfig"
                                    [topCards]="deployCardsConfig.cardsConfig?.topCards || []"
                                    [topCardsItemCountPerRow]="ItemPerRow.Two"
                                    [showSearchFilterLabel]="false"
                                    (cardDetail)="onCardDetail($event)"
                                    (topCardClick)="onDeploytopCardClick($event)">
                    </rappider-cards>
                  </div>
                </div>
              </div>
            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="collapsePanelConfigs[CollapsePanels.Deploy]!.actionButtons"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>
      </div>
    </div>

    <!-- SERVER -->
    <div *ngIf="activeWizardStep && activeWizardStep >= 15"
         class="project-design-container"
         [id]="CollapsePanels.Server">

      <div class="project-design-item-container">
        <nz-collapse>
          <nz-collapse-panel class="project-design-collapse-panel"
                             nzHeader="Server"
                             (nzActiveChange)="onCollapsePanelActiveChange(CollapsePanels.Server, $event)"
                             [nzActive]="(!allPanelsActive && !visiblePanelKeys?.length) ? false : allPanelsActive ? true : visiblePanelKeys?.includes(CollapsePanels.Server)">
            <ng-container *ngIf="visiblePanelKeys?.includes(CollapsePanels.Server)">
              <div class="template-wrapper">
                <div class="cards-with-preview">
                  <div class="cards-wrapper">
                    <rappider-cards [items]="serverCardsConfig.cardsConfig?.items || []"
                                    [itemCountPerRow]="serverCardsConfig.cardsConfig?.itemCountPerRow || ItemPerRow.Two"
                                    [showTitleOnImage]="serverCardsConfig.cardsConfig?.showTitleOnImage || false"
                                    [showDescriptionOnImage]="serverCardsConfig.cardsConfig?.showDescriptionOnImage || false"
                                    [selectConfig]="serverCardsConfig.cardsConfig?.selectConfig"
                                    [showSearchSection]="serverCardsConfig.cardsConfig?.showSearchSection || false"
                                    [titleText]="serverCardsConfig.cardsConfig?.titleText"
                                    [showCheckMarkOnCard]="serverCardsConfig.cardsConfig?.showCheckMarkOnCard || false"
                                    [customIcon]="serverCardsConfig.cardsConfig?.customIcon"
                                    [paginationConfig]="serverCardsConfig.cardsConfig?.paginationConfig"
                                    [topCards]="serverCardsConfig.cardsConfig?.topCards || []"
                                    [topCardsItemCountPerRow]="ItemPerRow.Two"
                                    [showSearchFilterLabel]="false"
                                    [detailedSearchActive]="true"
                                    (cardDetail)="onCardDetail($event)"></rappider-cards>
                  </div>
                </div>
              </div>
            </ng-container>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
      <div class="project-design-item-settings-container">
        <rappider-settings-button-group [buttons]="collapsePanelConfigs[CollapsePanels.Server]!.actionButtons || []"
                                        (buttonClicked)="onActionButtonClicked($event)"></rappider-settings-button-group>
      </div>
    </div>

    <!-- DEBUGGER -->
    <ng-container *ngIf="false"
                  [ngTemplateOutlet]="debugPanel"></ng-container>


    <!-- WIZARD -->
    <!-- <div class="project-design-container"
         *ngIf="wizardStepsConfigs?.length && wizardStepsConfigs[activeWizardStep]?.status === WizardStepStatus.InProgress">
      <div class="project-design-item-container">
        <nz-card class="blueprint-rappider-wizard-container project-design-container">
          <div class="blueprint-rappider-wizard-header">
            <div class="blueprint-rappider-wizard-logo-container">
              <img class="logo-image bouncing-rabbit"
                   src="assets/img/logo/white-rabbit-01.jpg"
                   alt="Rapider AI App Builder Wizard">
            </div>
            <div class="blueprint-rappider-wizard-title">
              <h2>
                {{((activeWizardStep || 0)+1) + '. ' + wizardStepsConfigs[activeWizardStep]?.title || 'Rapider AI App
                Builder
                Wizard'}}
              </h2>
            </div>
          </div>
          <ng-container [ngTemplateOutlet]="aiWizardContentTemplate"></ng-container>
        </nz-card>
      </div>
      <div class="project-design-item-settings-container">
      </div>
    </div> -->

    <!-- EXTRA WIZARD FOOTER -->
    <ng-container *ngIf="displayWizard && showWizardOnBluePrintFooter && wizardStepsConfigs?.length"
                  [ngTemplateOutlet]="aiWizardAdditionalFooter"></ng-container>

  </div>
  <!-- END OF BLUEPRINT FEATURES -->

</ng-template>
<!-- END OF BLUEPRINT MANAGER -->

<!-- AI Chat Modal - REMOVED -->
<!-- Modal functionality has been replaced with direct navigation to AI generation pages -->

<ng-template #aiWizardContentTemplate>
  <div [class]="'rapider-ai-wizard-content step_' + (activeWizardStep || 0) "
       #wizardContainer>
    <div class="wizard-content-markdown-container">
      <rappider-markdown-viewer
                                [markdownText]="wizardStepsConfigs[activeWizardStep]?.description || '...' "></rappider-markdown-viewer>
    </div>
    <div class="rapider-ai-wizard-footer">
      <div> </div>
      <div class="footer-right">
        <!-- <button *ngIf="displayNextUIPageButton"
                [id]="ProjectDesignSettingButtons.NextUIPageButton"
                nz-button
                nzType="default"
                (click)="onWizardNextUIPageButtonClicked()">Next Page</button> -->
        <!--
        <button *ngIf="wizardStepsConfigs[activeWizardStep]?.skippable"
                nz-button
                nzType="default"
                (click)="onWizardSkipStepsButtonClicked()">Skip</button> -->
        <button [id]="ProjectDesignSettingButtons.WizardNextButton"
                nz-button
                nzType="primary"
                [disabled]="activeWizardStep && wizardStepsConfigs[activeWizardStep]?.disableNextButton">
          <!-- (click)="onWizardNextStepButtonClicked()" -->
          {{activeWizardStep && activeWizardStep >= (wizardStepsConfigs?.length! - 1) ?
          'Complete the Wizard' : 'Next'}}</button>
      </div>
    </div>
  </div>

</ng-template>


<!-- This footer is displayed when the original footer is not visible -->
<ng-template #aiWizardAdditionalFooter>

  <div class="project-design-container footer-sticky">
    <div class="project-design-item-container footer-sticky-item-container">
      <nz-card class="blueprint-rappider-wizard-container project-design-container">
        <div class="blueprint-rappider-wizard-header">
          <div class="blueprint-rappider-wizard-logo-container">
            <img class="logo-image bouncing-rabbit"
                 src="/assets/wr/wr-welcome.gif"
                 alt="Rapider AI App Builder Wizard">
            <!-- src="assets/img/logo/white-rabbit-01.jpg" -->
          </div>
          <div class="blueprint-rappider-wizard-title">
            <h2>
              <span *ngIf="activeWizardStep">{{(+activeWizardStep) + '. '}}</span>
              <span>{{wizardStepsConfigs[activeWizardStep]?.title || 'Rapider AI App Builder
                Wizard'}}</span>
              <!-- Introduction  -->
              <!-- <div *ngIf="displayWizardOnIntroduction && wizardStepsConfigs?.length && wizardStepsConfigs[activeWizardStep]?.status === WizardStepStatus.Introduction"
                   class="wizard-content-markdown-container">
                <rappider-markdown-viewer [markdownText]="wizardStepsConfigs[activeWizardStep]?.introduction ">
                </rappider-markdown-viewer>
              </div> -->
            </h2>
          </div>
        </div>
        <div *ngIf="wizardStepsConfigs?.length && wizardStepsConfigs[activeWizardStep]?.status === WizardStepStatus.Introduction"
             class="wizard-content-markdown-container">

          <rappider-wizard-rabbit [activeProjectId]="activeProject?.id"
                                  [wizardStepsConfigs]="wizardStepsConfigs"
                                  [activeWizardStep]="activeWizardStep"
                                  [displayRabbitOnHeader]="false"
                                  (typingsCompleted)="onWizardModalTypingsCompleted($event)"></rappider-wizard-rabbit>

          <!--
          <rappider-markdown-viewer [markdownText]="wizardStepsConfigs[activeWizardStep]?.introductionExtra ">
          </rappider-markdown-viewer> -->
        </div>
        <div *ngIf="wizardStepsConfigs?.length && wizardStepsConfigs[activeWizardStep]?.status !== WizardStepStatus.Introduction"
             class="wizard-content-markdown-container">

          <rappider-timeline *ngIf="wizardStepsTimelineItems?.length"
                             [items]="wizardStepsTimelineItems"></rappider-timeline>

          <!-- <rappider-markdown-viewer [markdownText]="wizardStepsConfigs[activeWizardStep]?.description ">
          </rappider-markdown-viewer> -->
        </div>
        <div *ngIf="displayWizardNextButton"
             class="rapider-ai-wizard-additional-footer">
          <div class="footer-right">

            <!-- <button *ngIf="activeWizardStep && wizardStepsConfigs[activeWizardStep]?.skippable"
                    nz-button
                    nzType="default"
                    (click)="onWizardSkipStepsButtonClicked()">Skip</button> -->
            <button *ngIf="displayWizardNextButton"
                    [id]="ProjectDesignSettingButtons.WizardNextButton"
                    nz-button
                    nzType="primary"
                    [disabled]="activeWizardStep && wizardStepsConfigs[activeWizardStep]?.disableNextButton"
                    [nzLoading]="true">
              <!-- (click)="onWizardNextStepButtonClicked()"> -->
              {{wizardStepsConfigs[activeWizardStep]?.planTitle || 'Please wait while generating the next step...'}}
            </button>
          </div>
        </div>
      </nz-card>
    </div>
    <!-- <div class="project-design-item-settings-container">
    </div> -->
  </div>



</ng-template>

<ng-template #debugPanel>
  <div class="project-design-container">
    <div class="project-design-item-container">
      <nz-collapse>
        <nz-collapse-panel class="project-design-collapse-panel"
                           [nzActive]="true"
                           nzHeader="Debug Panel">
          <pre>activeWizardStep: {{activeWizardStep}}</pre>
          <pre
               *ngIf="wizardStepsConfigs?.length">activeWizardStep Config: {{wizardStepsConfigs[activeWizardStep] | json}}</pre>
        </nz-collapse-panel>
        <nz-collapse-panel class="project-design-collapse-panel"
                           nzHeader="Debug: activeProject">
          <pre>activeProject: {{activeProject | json}}</pre>
        </nz-collapse-panel>
        <nz-collapse-panel class="project-design-collapse-panel"
                           nzHeader="Debug: wizardStepsConfigs">
          <pre>wizardStepsConfigs: {{wizardStepsConfigs | json}}</pre>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
    <div class="project-design-item-settings-container">
    </div>
  </div>
</ng-template>

<ng-template #loremIpsum>
  <div>
    <!-- Reusable lorem ipsum to mock the text -->
    <p>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis commodo, lacus nec eleifend sollicitudin, mi
      nisi aliquet nulla, at vulputate urna eros rhoncus ante. Morbi interdum in nulla at pretium. Aenean eu urna
      condimentum, efficitur leo tincidunt, mattis neque. Nunc porttitor euismod urna id congue. Quisque sodales
      tempus pulvinar. Fusce hendrerit, est vel iaculis vestibulum, odio est scelerisque odio, sed aliquam justo
      lorem in ex. Ut semper dictum est. Morbi eget quam at est fringilla mattis. Mauris purus ligula, semper ac
      blandit vel, semper ut mi. Quisque volutpat mauris et ipsum venenatis viverra sit amet a leo.
    </p>
    <p>
      Duis sit amet quam ante. Pellentesque vel lorem scelerisque, mattis mi vitae, gravida massa. Nullam cursus
      egestas eleifend. Curabitur consectetur arcu at odio auctor faucibus. Nunc scelerisque tortor eget tortor
      ullamcorper, ut ultricies massa suscipit. Cras mattis cursus nibh, sed rutrum felis porta blandit. Duis
      libero lorem, ultricies eu ipsum quis, semper commodo nulla. Lorem ipsum dolor sit amet, consectetur
      adipiscing elit. Ut id nisl auctor, aliquam sapien quis, tempus odio. Praesent a mattis magna. Quisque sit
      amet ultricies dui, eget auctor risus. In vehicula leo eu vestibulum laoreet. Fusce ligula ligula, vehicula
      sit amet condimentum a, varius in ex.
    </p>
  </div>
</ng-template>

<ng-template #stepNotStarted>
  <div class="project-design-item-header-right">
    <i class="fa-solid fa-star"></i>
    <span>Not Started</span>
  </div>
</ng-template>

<ng-template #stepInProgress>
  <div class="project-design-item-header-right">
    <i class="fa-solid fa-cog fa-spin color-info"
       style="--fa-animation-duration: 8s;"></i>
    <span>In Progress</span>
  </div>
</ng-template>

<ng-template #stepCompleted>
  <div class="project-design-item-header-right">
    <i class="fa-solid fa-check color-success"></i>
    <span>Completed</span>
  </div>
</ng-template>

<ng-template #stepError>
  <div class="project-design-item-header-right">
    <i class="fa-solid fa-exclamation-triangle color-error"></i>
    <span>Error</span>
  </div>
</ng-template>

<ng-template #stepOptional>
  <div class="project-design-item-header-right">
    <i class="fa-solid fa-circle-info color-info"></i>
    <span>Optional</span>
  </div>
</ng-template>

<ng-template #stepNoStatus>
  <div class="project-design-item-header-right">
  </div>
</ng-template>

<!-- Mega Menu -->
<ng-template #megaMenuTemplate>
  <div class="mega-menu-container">
    <button nz-button
            nz-dropdown
            class="mega-menu-close-button"
            nzTrigger="click"
            (click)="onMegaMenuClose()">
      <rappider-icon [name]="'fas fa-close'"></rappider-icon>
    </button>
    <section class="customization-menu-content">
      <div class="feature-card-container row">
        <div *ngFor="let feature of projectMegaMenuFeatures; let i = index"
             class="feature-card  col-lg-3 col-md-3 col-sm-6 col-xs-12">
          <div class="feature-card-content">
            <i [class]="feature.icon"></i>
            <h5 class="feature-title">
              {{feature.title}}
            </h5>
            <p class="feature-description">
              {{feature.description}}
            </p>
            <div class="feature-links">
              <ng-container *ngFor="let subFeature of feature.subFeatures">
                <a *ngIf="subFeature?.isVisible !== false && subFeature?.title !== 'Invite Users'; else inviteUserTemplate"
                   class="feature-link"
                   [routerLink]="[subFeature.path]"
                   (click)="onMegaMenuClicked(subFeature)">{{subFeature.title}}</a>
                <ng-template #inviteUserTemplate>
                  <a *ngIf="isAdminOrManagerUser() && subFeature?.isVisible !== false"
                     class="feature-link"
                     [routerLink]="[subFeature.path]"
                     (click)="onMegaMenuClicked(subFeature)">{{subFeature.title}}</a>
                </ng-template>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</ng-template>

<ng-template #projectInfoTooltip>
  <div>
    <span *ngIf="tenant?.name"
          class="field-container">
      <span class="field">Tenant Name:</span>
      {{ tenant?.name }}
    </span>

    <span class="field-container">
      <span class="field">{{ 'Created By' | translate }} </span>
      {{ activeProject?.createdBy || '-' }}
      <span class="field">{{ 'at' | translate }} </span>
      {{ activeProject?.createdDate | formatDate}}
    </span>
  </div>
</ng-template>
